import { render, staticRenderFns } from "./ContactsName.vue?vue&type=template&id=4e3aaf04&scoped=true&"
import script from "./ContactsName.vue?vue&type=script&lang=js&"
export * from "./ContactsName.vue?vue&type=script&lang=js&"
import style0 from "./ContactsName.vue?vue&type=style&index=0&id=4e3aaf04&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3aaf04",
  null
  
)

export default component.exports